import { Zip, ZipPassThrough } from 'fflate'

// 이 임계값 초과 시 UI에서 경고 표시 (업로드는 허용)
export const ZIP_WARN_BYTES = 2 * 1024 * 1024 * 1024 // 2 GB

/**
 * File[] → ZIP Blob (STORE 모드, 압축 없음)
 *
 * 3D Mesh 바이너리(LAS, OBJ, FBX …)는 DEFLATE 압축률이 1~5% 수준이므로
 * 압축을 생략(ZipPassThrough = ZIP STORE)하고 파일을 청크 단위로 스트리밍해
 * 피크 메모리를 폴더 전체 크기의 ~1배로 억제한다.
 * (JSZip DEFLATE는 JS 메인 스레드에서 원본·압축본 모두 힙에 적재 → ~3배)
 */
export async function zipFolder(
  files: File[],
  onProgress?: (pct: number) => void,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const chunks: Uint8Array[] = []

    const zip = new Zip((err, data, final) => {
      if (err) { reject(err); return }
      chunks.push(data)
      if (final) resolve(new Blob(chunks as unknown as BlobPart[], { type: 'application/zip' }))
    })

    ;(async () => {
      const totalBytes = files.reduce((s, f) => s + f.size, 0)
      let doneBytes = 0

      for (const f of files) {
        const entry = new ZipPassThrough(f.webkitRelativePath || f.name)
        zip.add(entry)

        const reader = f.stream().getReader()
        try {
          while (true) {
            const { done, value } = await reader.read()
            if (done) {
              entry.push(new Uint8Array(0), true)
              break
            }
            entry.push(value, false)
            doneBytes += value.length
            if (totalBytes > 0) {
              onProgress?.(Math.round((doneBytes / totalBytes) * 100))
            }
          }
        } finally {
          reader.releaseLock()
        }
      }

      zip.end()
    })().catch(reject)
  })
}
